import { Component, ElementRef, ViewChild } from '@angular/core';
import { Cadastro } from 'src/app/service/classes/cadastro/cadastro';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertaModal } from '../componentes-funcionais/alerta-modal/alerta-modal.component';
import { LotacoesVinculadasService } from './lotacoes-vinculadas.service';
import Swal from 'sweetalert';
import { LocalStorage } from 'src/app/service/classes/localstorage/LocalStorage';
import { Crypto } from 'src/app/service/classes/crypto/crypto';
import { ObservacoesFichaFuncionalComponent } from '../componentes-funcionais/observacoes-ficha-funcional/observacoes-ficha-funcional.component';
import { AnexoComponent } from '../anexo/anexo.component';
import { LotacoesVinculadasCadastroComponent } from './lotacoes-vinculadas-cadastro/lotacoes-vinculadas-cadastro.component';
import { Router } from '@angular/router';
import { ErroService } from 'src/app/service/erros/erro.service';

@Component({
  selector: 'app-lotacoes-vinculadas',
  templateUrl: './lotacoes-vinculadas.component.html',
  styleUrls: ['./lotacoes-vinculadas.component.css'],
})
export class LotacoesVinculadasComponent {
  @ViewChild(AnexoComponent) modalAnexo: AnexoComponent;
  @ViewChild(ObservacoesFichaFuncionalComponent)
  modalObservacoes: ObservacoesFichaFuncionalComponent;

  matricula: number = null;
  formColaborador: FormGroup;
  colaborador: Cadastro = null;
  loading: boolean = false;
  listaLotacao: Lotacao[] = [];
  localStorage: LocalStorage;
  empfil: string;
  tipoPagina: string = '209';
  numeroOrdem: string;

  tiposLotacao: any[] = [];
  carregandoLotacoes = false;

  instanciaModalLotacao: any;

  formLotacao: FormGroup;
  cadastroLotacao: boolean = true;
  lotacaoAtual: Lotacao | null = null;

  constructor(
    public fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private lotacaoService: LotacoesVinculadasService,
    private route: Router,
    private erroService: ErroService
  ) {
    this.localStorage = this.decryptLocalStorage();
    console.log('localstorage', this.localStorage);
    this.formColaborador = this.fb.group({
      matricula: ['', Validators.required],
      nome: [''],
    });
    this.formLotacao = this.fb.group({
      CodigoLoteModal: [''],
      DataInicioModal: [''],
      DataFimModal: [''],
    });

    const navigation = this.route.getCurrentNavigation();
    if (navigation.extras.state) {
      console.log(navigation);
      this.matricula = navigation.extras.state.usuario.matricula;
      this.formColaborador.get('matricula').setValue(this.matricula);
    }
  }

  decryptLocalStorage(): LocalStorage {
    if (localStorage.getItem('util') != null) {
      return JSON.parse(new Crypto().decryptUsingAES256(localStorage.getItem('util')));
    }
  }

  ngAfterViewInit() {
    const modalElement = document.getElementById('lotacaoModal');
    if (modalElement) {
      this.instanciaModalLotacao = new (window as any).bootstrap.Modal(modalElement);
    }
  }

  buscarColaboradorMatricula(matricula) {
    this.spinner.show();
    this.lotacaoService.buscarColaboradorMatricula(matricula).subscribe(
      (data: Cadastro) => {
        console.log(data);
        this.numeroOrdem = data.NumeroDeOrdem;
        this.empfil = data.Filial.Codigo;
        this.setarFormColaborador(data);
        this.colaborador = data;
        this.spinner.hide();
      },
      (error) => {
        this.erroService.retornoErro(error);
        this.retornarTelaInicial();
        this.spinner.hide();
      }
    );
  }

  matriculaListener(evento) {
    this.matricula = evento.Matricula;
    this.buscarColaboradorMatricula(this.matricula);
    this.modalAnexo.inicializarComponente(evento);
  }

  setarFormColaborador(data) {
    this.formColaborador.get('matricula').disable();
    this.formColaborador.get('matricula').setValue(this.matricula);
    this.formColaborador.get('nome').disable();
    this.formColaborador.get('nome').setValue(data.InformacoesBasicas.NomeCompleto);
    this.loading = false;
    this.buscarLotacao();
  }

  retornarTelaInicial() {
    this.matricula = null;
    this.formColaborador.reset();
    this.formColaborador.markAsPristine();
  }

  buscarLotacao() {
    this.spinner.show();

    this.lotacaoService.buscarLotacao().subscribe(
      (data: Lotacao[]) => {
        console.log('Dados recebidos:', data);
        this.listaLotacao = data;
        this.spinner.hide();
      },
      (error) => {
        this.erroService.retornoErro(error);
        this.retornarTelaInicial();
        this.spinner.hide();
      }
    );
  }

  buscarLotacaoModal(Codigo: number) {
    this.spinner.show();
    this.lotacaoService.buscarLotacaoModal(Codigo).subscribe(
      (data: Lotacao) => {
        this.lotacaoAtual = data;
        this.cadastroLotacao = false;

        this.carregarTiposLotacao(() => {
          this.formLotacao.get('CodigoLoteModal')?.clearValidators();
          this.formLotacao.get('DataInicioModal')?.clearValidators();
          this.formLotacao.get('CodigoLoteModal')?.updateValueAndValidity();
          this.formLotacao.get('DataInicioModal')?.updateValueAndValidity();

          this.preencherFormularioEdicao();
          this.showModal();
          this.spinner.hide();
        });
      },
      (error) => {
        this.erroService.retornoErro(error);
        this.retornarTelaInicial();
        this.spinner.hide();
      }
    );
  }

  carregarTiposLotacao(callback?: () => void) {
    this.carregandoLotacoes = true;
    this.lotacaoService.buscarTiposLotacao(this.empfil).subscribe(
      (data: any[]) => {
        this.tiposLotacao = data;
        this.carregandoLotacoes = false;

        setTimeout(() => {
          if (callback) callback();
        }, 0);
      },
      (error) => {
        this.erroService.retornoErro(error);
        this.carregandoLotacoes = false;
        this.spinner.hide();
      }
    );
  }

  showModal() {
    if (this.instanciaModalLotacao) {
      this.instanciaModalLotacao.show();
    }
  }

  hideModal() {
    if (this.instanciaModalLotacao) {
      this.instanciaModalLotacao.hide();
    }
  }

  openModal() {
    this.carregarTiposLotacao(() => {
      this.cadastroLotacao = true;
      this.formLotacao.reset();
      this.lotacaoAtual = null;
      this.setupFormValidators();
      this.showModal();
    });
  }

  closeModal() {
    this.hideModal();
  }

  private setupFormValidators() {
    this.formLotacao.get('CodigoLoteModal')?.setValidators([Validators.required]);
    this.formLotacao.get('DataInicioModal')?.setValidators([Validators.required]);
    this.formLotacao.get('CodigoLoteModal')?.updateValueAndValidity();
    this.formLotacao.get('DataInicioModal')?.updateValueAndValidity();
  }

  preencherFormularioEdicao() {
    if (!this.lotacaoAtual) return;

    console.log('Preenchendo formulário com:', {
      CodigoLote: this.lotacaoAtual.CodigoLote,
      DataInicio: this.lotacaoAtual.DataInicio,
      DataFim: this.lotacaoAtual.DataFim,
    });

    this.formLotacao.patchValue({
      CodigoLoteModal: this.lotacaoAtual.CodigoLote?.toString() || '',
      DataInicioModal: this.formatarDataParaInput(this.lotacaoAtual.DataInicio),
      DataFimModal: this.lotacaoAtual.DataFim?.Empty
        ? ''
        : this.formatarDataParaInput(this.lotacaoAtual.DataFim),
    });

    this.formLotacao.updateValueAndValidity();
  }

  private formatarDataParaInput(data: any): string {
    if (!data || data.Empty) return '';

    if (typeof data === 'string') {
      return data.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
    } else if (data?.SetData && data.SetData.length === 8) {
      return `${data.SetData.substr(0, 4)}-${data.SetData.substr(4, 2)}-${data.SetData.substr(
        6,
        2
      )}`;
    }
    return '';
  }

  salvarLotacao() {
    this.spinner.show();

    if (this.cadastroLotacao && this.formLotacao.invalid) {
      this.formLotacao.markAllAsTouched();

      Swal('Campos obrigatórios', 'Preencha todos os campos obrigatórios.', 'warning');

      this.spinner.hide();
      return;
    }

    const dados: any = {
      CodigoLote: this.formLotacao.value.CodigoLoteModal,
      DataInicio: this.formatarDataParaAPI(this.formLotacao.value.DataInicioModal)
        ? {
            SetData: this.formLotacao.value.DataInicioModal.replace(/-/g, ''),
          }
        : undefined,

      DataFim: this.formatarDataParaAPI(this.formLotacao.value.DataFimModal)
        ? {
            SetData: this.formLotacao.value.DataFimModal.replace(/-/g, ''),
          }
        : undefined,
      Empfil: this.colaborador.Filial.Codigo,
      // Mat: this.colaborador.Matricula,
      NumeroOrdem: this.numeroOrdem,
    };

    if (!this.cadastroLotacao && this.lotacaoAtual?.Codigo) {
      dados.Codigo = this.lotacaoAtual.Codigo;
    }

    const observable = this.cadastroLotacao
      ? this.lotacaoService.adicionarLotacao(dados)
      : this.lotacaoService.editarLotacao(dados);

    observable.subscribe({
      next: () => {
        this.buscarLotacao();
        this.closeModal();
        Swal(
          'Sucesso',
          `Lotação ${this.cadastroLotacao ? 'cadastrada' : 'atualizada'} com sucesso!`,
          'success'
        );
        this.spinner.hide();
      },
      error: (error) => {
        console.error(error);

        const mensagemErro = error?.error?.message || error?.error?.Mensagem;

        Swal(
          'Erro',
          `Não foi possível ${
            this.cadastroLotacao ? 'cadastrar' : 'atualizar'
          } a lotação.\n\n${mensagemErro}`,
          'error'
        );

        this.spinner.hide();
      },
    });
  }

  private formatarDataParaAPI(dataString: string): string {
    if (!dataString) return '';

    return dataString.replace(/-/g, '');
  }

  deletarLotacao(lotacao: Lotacao) {
    Swal({
      title: 'Deseja realmente excluir essa Lotação?',
      text: 'Essa ação não pode ser desfeita.',
      icon: 'warning',
      buttons: ['Cancelar', 'Confirmar'],
    }).then((willDelete) => {
      if (willDelete) {
        this.spinner.show();
        this.lotacaoService.deletarLotacao(lotacao.Codigo).subscribe(
          () => {
            this.buscarLotacao();
            Swal('Sucesso', 'Lotação excluída com sucesso!', 'success');
            this.spinner.hide();
          },
          (error) => {
            this.erroService.retornoErro(error);
            this.retornarTelaInicial();
            this.spinner.hide();
          }
        );
      }
    });
  }
}

export interface Lotacao {
  Sigla: string;
  Documento: 'S' | 'N';
  Obs: 'S' | 'N';
  Empfil: string;
  DescricaoSetorPrincipal: string;
  DescricaoSetorVinculado: string;
  CPF: string;

  Mat: number;
  Codigo: number;
  CodigoLote: string;
  DataInicio: {
    ToDate: string;
    SetData?: string;
    Empty?: boolean;
    IsDate?: boolean;
  };
  DataFim: {
    ToDate: string;
    SetData?: string;
    Empty?: boolean;
    IsDate?: boolean;
  };
  Seq?: number;
}
